import { Component, inject, input, output } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { GroupSelectionService } from '@vectronic/util';

@Component({
  selector: 'table-datatable-groups-checkbox',
  templateUrl: './datatable-groups-checkbox.component.html',
  styleUrls: ['./datatable-groups-checkbox.component.scss'],
  imports: [MatCheckboxModule],
})
export class DatatableGroupsCheckboxComponent {
  row = input<any>();

  checkboxToggle = output<boolean>();

  private groupSelectionService = inject(GroupSelectionService);

  onCheckboxToggle(event: MatCheckboxChange) {
    this.groupSelectionService.selectGroup(this.row());
    this.checkboxToggle.emit(event.checked);
  }

  checkedStatus() {
    return this.groupSelectionService.isSelected(this.row().id);
  }
}
